import CommentView from './CommentView'
const commentRoutes = [{ path: '/comments/:_id', component: CommentView }]
export default commentRoutes
